module.exports = __webpack_public_path__ + "img/icon_set_minus_24.3d453a57.svg";